import { useCallback, useEffect, useState } from 'react';
import { buddiesService } from '../features/features/services/buddiesService';
import { getCachedInTheStandCount, setCachedInTheStandCount } from '../utils/buddiesCache';

export const IN_THE_STAND_CHANGED_EVENT = 'yona:in-the-stand-changed';

export function notifyInTheStandChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(IN_THE_STAND_CHANGED_EVENT));
  }
}

/**
 * Count of viewer + hunting buddies currently tagged into a stand.
 */
export function useInTheStandCount({ enabled = true, pollMs = 15000 } = {}) {
  const [count, setCount] = useState(() => getCachedInTheStandCount({ allowStale: true }) ?? 0);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const next = Number(await buddiesService.getInTheStandCount()) || 0;
      setCount(next);
      setCachedInTheStandCount(next);
    } catch {
      // chrome badge is best-effort
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }
    refresh();
    const onChange = () => {
      refresh();
    };
    window.addEventListener(IN_THE_STAND_CHANGED_EVENT, onChange);
    const intervalId = setInterval(refresh, pollMs);
    return () => {
      window.removeEventListener(IN_THE_STAND_CHANGED_EVENT, onChange);
      clearInterval(intervalId);
    };
  }, [enabled, pollMs, refresh]);

  return { count, refresh };
}
